import React, { useEffect, useRef, useMemo } from "react"
import { useSearchBox } from "react-instantsearch"
import debounce from "lodash/debounce"

const connectSearchBox = (Component: any) => {
  const SearchBox = (props: any) => {
    const data = useSearchBox()
    return <Component {...props} {...data} />
  }
  return SearchBox
}

interface SearchBoxProps {
  searchText: string,
  refine: any,
  searchDeployed: boolean,
  setSearchText: any,
  searchPlaceholderText: string,
}

const SearchBox = ({
  searchText,
  refine,
  searchDeployed,
  setSearchText,
  searchPlaceholderText,
}: SearchBoxProps) => {
  const searchInputRef = useRef(null)

  useEffect(() => {
    refine(searchText)
  }, [searchText, refine, searchInputRef])

  const changeHandler = (searchText: any) => {
    refine(searchText)
  }
  /* eslint-disable-next-line react-hooks/exhaustive-deps */
  const debouncedChangeHandler = useMemo(() => debounce(changeHandler, 300), [])

  const keyDownHandler = (e: any) => {
    //Suppress enter key
    e?.preventDefault()
    refine(searchText)
  }

  return (
    <>
      <div className="nav-search__search-box">
        <form
          className="nav-search__search-box--form"
          action=""
          role="search"
          noValidate
          onSubmit={keyDownHandler}
        >
          <input
            className="nav-search__search-box--input"
            ref={searchInputRef}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            placeholder={searchPlaceholderText}
            spellCheck={false}
            maxLength={512}
            type="search"
            value={searchText}
            aria-label="“Search blog articles. Pressing “enter” executes the search."
            onChange={e => {
              setSearchText(e.target.value)
              debouncedChangeHandler(e.target.value)
            }}
          />
        </form>
      </div>
      <div className="nav-search__search-box--blue-divider" />
    </>
  )
}

const CustomSearchBox = connectSearchBox(SearchBox)

export default CustomSearchBox
